<div class="main-div">
    <div class="row ms-0 me-0">
        <div class="col-xl-6 ps-0 pe-0 before-arrow-img">
            <img src="../assets/images/about/about-us.jpg" alt="About us" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"> About Us</h2>
                <p class="font-16">Strait Air Transport is a specialist in all solutions related to the air freight business. Additionally, as a full freight forwarder, we offer express, ocean freight, sea/air, rail and road transport.
                    <br><br> Our experienced staff are at your service 24 hours a day to provide the right solution – a first class, efficient and cost-effective solution matching your requirements with proper handling of your cargo assured.</p>
            </div>
        </div>
    </div>

    <div class="sat-history">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <img src="../assets/images/about/SAT-Timeline.png" alt="SAT Timeline" class="img-fluid">
                </div>
            </div>
        </div>
    </div>


    <div class="row ms-0 me-0">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 before-arrow-img-2">
            <img src="../assets/images/about/history.jpg" alt="History" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"> History</h2>
                <p class="font-16">
                    Our Scan-Group history covers over 50 years with air freight services in Denmark since 1979 upon our official IATA approval.</p>

                <p class="font-16">On the first day of the New Millennium January 1st 2000, all Nordic air freight activities were transferred to the newly established (fully-owned) Strait Air Transport.</p>

                <p class="font-16"> Today Strait Air Transport operates 9 offices in Denmark, Sweden, Norway, Finland and Estonia.
                </p>
            </div>
        </div>
    </div>

</div>